<template>
  <div class="table-wrap">
    <el-table ref="table" :data="tableData" :height="tHeight || tableHeight || 555" stripe border
      :row-class-name="tableRowClassName" :show-summary="showTotal" :summary-method="getTotal"
      :header-cell-style="{ 'background-color': '#E8ECEF', 'color': '#333', 'height': '59px' }" style="width: 100%"
      @selection-change="handleSelectionChange" @sort-change="handleSortChange">
      <!-- 复选框列 -->
      <el-table-column v-if="showSelect" type="selection" width="55" align="center">
      </el-table-column>
      <!-- 序号列 -->
      <el-table-column v-if="showIndex" type="index" label="序号" width="55" align="center"
        :index="indexMethod"></el-table-column>
      <!-- 常规列 -->
      <el-table-column v-for="(c, i) in cols" :key="i" :prop="c.prop || c.keyName" :label="c.label"
        :min-width="c.minwidth || c.width" :align="c.align || 'center'" :sortable="c.sortable" :class-name="c.className"
        :fixed="c.fixed">
        <template slot-scope="scope">
          <!-- 有插槽则显示插槽 -->
          <template v-if="c.slot">
            <slot :name="c.slot" :params="scope.row" :col="c"></slot>
          </template>
          <!-- 没有则显示默认内容 -->
          <template v-else>
            <!-- 0 或者其他值直接展示，否则显示'-' -->
            {{ (scope.row[c.prop || c.keyName] === 0 || scope.row[c.prop || c.keyName]) ? scope.row[c.prop || c.keyName]
              : '-' }}
          </template>
        </template>
      </el-table-column>
      <!-- 按钮列 -->
      <el-table-column v-if="btns && btns.length" :width="allBtnWidth || `${26 * btns.length + 60}px` || '140px'"
        align="center" label="操作" fixed="right">
        <template #default="scope">
          <Btn v-for="(n, j) in btns" :key="`btn${j}`" :config="n" :data="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <Pagination v-if="page && limit && total" :currentPage="page" :pageSize="limit" :total="total" :layout="layout"
      :pageSizes="pageSizes" :background="background" @onSizeChange="onSizeChange" @onCurrentChange="onCurrentChange" />
  </div>
</template>

<script>
import {
  mapState,
} from "vuex";

export default {
  name: "Table",
  props: {
    tableData: Array,
    cols: Array,
    btns: Array,
    allBtnWidth: [String, Number],
    page: Number,
    limit: Number,
    total: Number,
    showTotal: Boolean,
    getTotal: Function,
    showSelect: Boolean,
    pageSizes: Array,
    layout: String,
    background: Boolean,
    stripe: Boolean,
    showIndex: Boolean,
    tableHeight: Number,
  },
  data() {
    return {
      tHeight: 310,
      scrollTop: 0,
    };
  },
  computed: {
    ...mapState([
      'user',
      'store',
    ]),
  },
  methods: {
    doLayout() {
      // console.log(this.$refs.table)
      this.$nextTick(() => {
        this.$refs.table.doLayout()
        this.setTableHeight()
      })
    },
    setTableHeight() {
      let height = document.documentElement.offsetHeight
      // console.log('height', height)
      height -= 66 + 20 + 40 + 30 + 32 + 30
      const radio = document.querySelector('.page-menu.el-menu')
      if (radio) {
        height -= 38 + 20
      }
      const tab = document.querySelector('.con-menu.el-menu')
      if (tab) {
        height -= 36 + 15
      }
      const search = document.querySelector('.fillet')
      if (search) {
        height -= 92
        if (search.offsetHeight > 92) {
          height -= 66
        }
      }
      const dataShow = document.querySelector('.dataShow')
      if (dataShow) {
        height -= 158
      }
      // console.log('height', height)
      this.tHeight = height
    },
    indexMethod(i) {
      return (this.page - 1) * this.limit + i + 1
    },
    tableRowClassName({ row }) {
      // console.log(row)
      if (row.viewed) {
        return 'viewed';
      }
      return '';
    },
    onSizeChange(n) {
      // console.log(n);
      this.$emit("onSizeChange", n);
    },
    onCurrentChange(n) {
      // console.log(n);
      this.$emit("onCurrentChange", n);
    },
    handleSelectionChange(val) {
      this.$emit("onSelectionChange", val);
    },
    handleSortChange(v) {
      this.$emit("onSortChange", v);
    },
    saveScrollPosition(e) {
      // console.log(e)
      this.scrollTop = e.target.scrollTop;
      // console.log(this.scrollTop)
    },
    setScrollTop() {
      const path = this.$route.path
      // 刷新数据时调用此方法
      setTimeout(() => {
        if (this.store && this.store['scrollTop' + path]) {
          this.scrollTop = this.store['scrollTop' + path]
        }
        // console.log('store 2', { ...this.store })
        // console.log('scrollTop', this.scrollTop)
        this.$refs.table.bodyWrapper.scrollTop = this.scrollTop || 0;
        this.doLayout()
      }, 0);
    },
  },
  mounted() {
    // console.log('mounted')
    const table = this.$refs.table.$el
    // console.log(table)
    const tableWrap = table.querySelector('.el-table__body-wrapper')
    // console.log(tableWrap)
    // console.log(this.$refs.table.bodyWrapper)
    tableWrap.addEventListener('scroll', this.saveScrollPosition);
  },
};
</script>

<style lang="less" scoped>
.table-wrap {

  /deep/ .el-table {
    .viewed {
      color: #989490;
    }

    // 覆盖复选框列默认样式
    .el-table-column--selection .cell {
      padding-left: 10px;
      padding-right: 10px;
    }

    .el-table__body-wrapper {
      &::-webkit-scrollbar {
        // width: 6px;
        height: 10px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #ddd;
        border-radius: 5px;
      }
    }

    .el-table__fixed,
    .el-table__fixed-right {
      height: 100% !important;
    }
  }
}
</style>
